(()=>{const start=()=>{document.querySelectorAll('.wim-dept__slider').forEach(box=>{if(box.dataset.ready)return;box.dataset.ready='1';const track=box.querySelector('.wim-dept__track'),slides=[...track.children];if(!slides.length)return;let i=0,playing=!matchMedia('(prefers-reduced-motion: reduce)').matches,timer;const count=box.querySelector('[data-slide-count]'),toggle=box.querySelector('[data-slide-toggle]');const go=n=>{i=(n+slides.length)%slides.length;track.scrollTo({left:track.clientWidth*i,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};const update=()=>{i=Math.round(track.scrollLeft/track.clientWidth);count.textContent=(i+1)+' / '+slides.length;};track.addEventListener('scroll',update,{passive:true});box.querySelectorAll('[data-slide-step]').forEach(b=>b.addEventListener('click',()=>go(i+Number(b.dataset.slideStep))));const reset=()=>{clearInterval(timer);if(playing&&slides.length>1)timer=setInterval(()=>{if(!document.hidden)go(i+1)},6000);toggle.textContent=playing?'Ⅱ':'▶';toggle.setAttribute('aria-label',playing?toggle.dataset.pause:toggle.dataset.play)};if(!toggle||!count)return;toggle.addEventListener('click',()=>{playing=!playing;reset()});box.addEventListener('mouseenter',()=>clearInterval(timer));box.addEventListener('mouseleave',reset);box.addEventListener('focusin',()=>clearInterval(timer));box.addEventListener('focusout',reset);reset()});document.querySelectorAll('.wim-gy-categories').forEach(nav=>{if(nav.dataset.ready)return;nav.dataset.ready='1';nav.id=nav.id||'WimCategoryTrack';const controls=document.createElement('div');controls.className='wim-category-controls';[-1,1].forEach(dir=>{const b=document.createElement('button');b.type='button';b.textContent=dir<0?'←':'→';b.setAttribute('aria-label',dir<0?window.wimDept.previous:window.wimDept.next);b.setAttribute('aria-controls',nav.id);b.addEventListener('click',()=>nav.scrollBy({left:dir*nav.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));controls.append(b)});nav.before(controls)})};start();document.addEventListener('shopify:section:load',start);
const config = window.wimDept;
if (!config || typeof config.clearBlocked !== 'string' || typeof config.cleared !== 'string') return;
const key = 'wim_recent_GY_v1';
const allowed = () => {
  try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; }
  catch { return false; }
};
let historyRun = 0;
let clearedForPage = false;
let clearMessage = '';
const requests = new Set();
const cancelHistory = () => {
  ++historyRun;
  requests.forEach(controller => controller.abort());
  requests.clear();
};
const recent = async () => {
  cancelHistory();
  const run = historyRun;
  const box = document.querySelector('[data-wim-recent]');
  const list = box?.querySelector('[data-recent-items]');
  const empty = box?.querySelector('[data-recent-empty]');
  const clear = box?.querySelector('[data-clear-recent]');
  if (box && empty && !Object.hasOwn(box.dataset, 'originalEmptyText')) box.dataset.originalEmptyText = empty.textContent;
  list?.replaceChildren();
  document.body.dataset.wimHistoryStatus = 'api-pending';
  if (typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed !== 'function') {
    if (box) box.hidden = true;
    return;
  }
  if (!allowed()) {
    document.body.dataset.wimHistoryStatus = 'consent-required';
    if (box) {
      box.hidden = false;
      box.querySelector('[data-recent-preference]').hidden = false;
      clear.hidden = true;
      empty.textContent = box.dataset.originalEmptyText;
      empty.hidden = false;
      box.querySelector('[data-remember-recent]').onclick = () => Shopify.customerPrivacy.setTrackingConsent({ preferences: true }, () => recent());
    }
    return;
  }
  if (clearedForPage) {
    if (box) {
      box.querySelector('[data-recent-preference]').hidden = true;
      clear.hidden = true;
      empty.textContent = clearMessage;
      empty.hidden = false;
      box.hidden = false;
    }
    return;
  }
  document.body.dataset.wimHistoryStatus = 'allowed';
  let entries = [];
  try {
    const raw = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(raw)) entries = raw.filter(entry => entry && /^[a-z0-9-]+$/.test(entry.h) && Date.now() - entry.t < 2592000000).slice(0, 20);
    if (config.product) {
      entries = [{ h: config.product, t: Date.now() }, ...entries.filter(entry => entry.h !== config.product)].slice(0, 20);
      localStorage.setItem(key, JSON.stringify(entries));
      document.body.dataset.wimHistoryStatus = 'recorded';
    }
  } catch {
    if (box) box.hidden = true;
    return;
  }
  if (!box) return;
  box.querySelector('[data-recent-preference]').hidden = true;
  empty.textContent = box.dataset.originalEmptyText;
  clear.onclick = () => {
    cancelHistory();
    clearedForPage = true;
    let removed = false;
    try { localStorage.removeItem(key); removed = true; } catch {}
    list.replaceChildren();
    box.hidden = false;
    clear.hidden = true;
    clearMessage = removed ? config.cleared : config.clearBlocked;
    empty.textContent = clearMessage;
    empty.hidden = false;
    empty.setAttribute('role', 'status');
    empty.setAttribute('aria-live', 'polite');
    empty.setAttribute('aria-atomic', 'true');
    empty.setAttribute('tabindex', '-1');
    empty.focus({ preventScroll: true });
    document.body.dataset.wimHistoryStatus = removed ? 'cleared' : 'clear-blocked';
  };
  clear.hidden = !entries.length;
  if (!entries.length) {
    box.hidden = false;
    empty.hidden = false;
    return;
  }
  empty.hidden = true;
  const products = await Promise.all(entries.slice(0, 8).map(async entry => {
    if (run !== historyRun || !allowed() || clearedForPage) return null;
    const controller = new AbortController();
    requests.add(controller);
    try {
      const response = await fetch(config.root + 'products/' + encodeURIComponent(entry.h) + '.js', { signal: controller.signal });
      if (!response.ok) return null;
      return await response.json();
    } catch { return null; }
    finally { requests.delete(controller); }
  }));
  if (run !== historyRun || !allowed() || clearedForPage) return;
  list.replaceChildren();
  for (const product of products.filter(Boolean)) {
    const link = document.createElement('a');
    link.className = 'wim-dept__product';
    link.href = config.root + 'products/' + encodeURIComponent(product.handle);
    if (product.featured_image) {
      const image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 240;
      image.height = 240;
      link.append(image);
    }
    const title = document.createElement('h3');
    title.textContent = product.title;
    link.append(title);
    if (!product.available) {
      const status = document.createElement('span');
      status.className = 'wim-dept__stock';
      status.textContent = box.dataset.sold;
      link.append(status);
    }
    const action = document.createElement('span');
    action.textContent = box.dataset.view + ' →';
    link.append(action);
    list.append(link);
  }
  box.hidden = false;
  empty.hidden = !!list.children.length;
};
const init = () => recent();
if (window.Shopify?.customerPrivacy) init();
else if (window.Shopify?.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) init(); });
window.addEventListener('pageshow', init);
window.addEventListener('pagehide', () => { cancelHistory(); document.querySelector('[data-recent-items]')?.replaceChildren(); });
document.addEventListener('visitorConsentCollected', () => {
  if (!allowed()) { try { localStorage.removeItem(key); } catch {} }
  init();
});
document.addEventListener('shopify:section:load', init);
})();
